import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Accordion, AccordionCollapse, AccordionCollapseStyled, AccordionItem, AccordionToggle, AccordionToggleStyled, } from '@awaze/design-system.components.accordion';
import { pxToRems } from '@awaze/design-system.components.global-style';
import { Stack, StackStyled } from '@awaze/design-system.components.stack';
import { Text } from '@awaze/design-system.components.text';
import { destinations as JSONdestinations } from '@awaze/design-system.compositions.form-fields';
import styled, { css } from 'styled-components';
import React from 'react';
import { StyledDestinationItem } from './destination-item';
import { DestinationList } from './destination-list';
import { getFilteredDestinations, getPopularDestinations, } from './destination-shared-utils';
import { useSearchFormContext } from '../../search-form.context';
const StyledAccordion = styled(Accordion) `
  ${StackStyled} {
    padding-left: ${pxToRems(16)};
    background-color: #f8f8f8;
  }

  ${StackStyled} ${StackStyled} {
    padding-left: 0;
  }

  ${AccordionToggleStyled} {
    padding-left: ${pxToRems(16)};
    padding-right: ${pxToRems(16)};
  }

  ${AccordionCollapseStyled} {
    padding-bottom: 0;
  }

  // Temporary override for Legacy Destinations styling
  ${({ $useLegacyDestinationSelector }) => $useLegacyDestinationSelector &&
    css `
      margin: 0 -16px;
    `}
`;
export const DestinationAccordion = ({ closeAccordion, translations, isBoatsDestinations = false, useLegacyDestinationSelector = true, }) => {
    // Wait for places data to load.
    const { legacyListWithPlaces } = useSearchFormContext();
    const isLoading = legacyListWithPlaces?.enabled &&
        !isBoatsDestinations &&
        legacyListWithPlaces?.data === null;
    if (isLoading) {
        return (_jsx(StyledAccordion, { children: _jsx("p", { children: "Loading ..." }) }));
    }
    const dataSource = legacyListWithPlaces?.enabled &&
        !isBoatsDestinations &&
        legacyListWithPlaces?.data?.length
        ? legacyListWithPlaces.data
        : JSONdestinations;
    const destinations = getFilteredDestinations(dataSource, isBoatsDestinations);
    return (_jsxs(StyledAccordion, { "$useLegacyDestinationSelector": useLegacyDestinationSelector, children: [destinations.map((region) => (_jsxs(AccordionItem, { children: [_jsx(AccordionToggle, { children: _jsx(Text, { sizes: 300, type: "bold", children: region.regionName }) }), _jsx(AccordionCollapse, { children: _jsxs(Stack, { spacing: 0, children: [region.regions && (_jsx(DestinationList, { locations: region.regions, closeAccordion: closeAccordion })), region.popular && (_jsxs(_Fragment, { children: [_jsx(StyledDestinationItem, { as: "div", children: _jsx(Text, { sizes: 300, type: "mid", children: translations.popularAreas }) }), _jsx(DestinationList, { locations: region.popular.locations, closeAccordion: closeAccordion })] }))] }) })] }, `accordion-${region.regionId}`))), !isBoatsDestinations && (_jsxs(AccordionItem, { children: [_jsx(AccordionToggle, { children: _jsx(Text, { sizes: 300, type: "bold", children: translations.popularDestinations }) }), _jsx(AccordionCollapse, { children: _jsx(Stack, { spacing: 0, children: getPopularDestinations(dataSource).map((popularDestinations) => (_jsxs(React.Fragment, { children: [_jsx(StyledDestinationItem, { as: "div", children: _jsx(Text, { sizes: 300, type: "mid", children: popularDestinations.title }) }), _jsx(DestinationList, { locations: popularDestinations.locations, closeAccordion: closeAccordion })] }, `accordion-popular-destinations${popularDestinations.title}`))) }) })] }))] }));
};
//# sourceMappingURL=destination-accordion.js.map